import * as betHistoryConstants from './betHistoryConstants';

export const CDN_URL_TMP = 'https://d29bnxtiec58nc.cloudfront.net';
export const { BASE_PATH, THEME_PATH } = window;
export const { template: TEMPLATE } = window.SYS_CONFIG || {};
export { betHistoryConstants };
export const currencyIcons = {
  AED: 'د.إ',
  AFN: '؋',
  ALL: 'L',
  AMD: '֏',
  ANG: 'ƒ',
  AOA: 'Kz',
  ARS: '$',
  AUD: '$',
  AWG: 'ƒ',
  AZN: '₼',
  B9C: 'B9C',
  BAM: 'KM',
  BBD: '$',
  BDT: '৳',
  BGN: 'лв',
  BHD: '.د.ب',
  BIF: 'FBu',
  BMD: '$',
  BND: '$',
  BOB: '$b',
  BRL: 'R$',
  BSD: '$',
  BTC: 'BTC',
  BTN: 'Nu.',
  BWP: 'P',
  BYN: 'Br',
  BYR: 'Br',
  BZD: 'BZ$',
  CAD: '$',
  CDF: 'FC',
  CHF: 'CHF',
  CLP: '$',
  CNY: '¥',
  COP: '$',
  CRC: '₡',
  CUC: '$',
  CUP: '₱',
  CVE: '$',
  CZK: 'Kč',
  DJF: 'Fdj',
  DKK: 'kr',
  DOP: 'RD$',
  DZD: 'دج',
  EEK: 'kr',
  EGP: '£',
  ERN: 'Nfk',
  ETB: 'Br',
  ETH: 'ETH',
  EUR: '€',
  FJD: '$',
  FKP: '£',
  GBP: '£',
  GEL: '₾',
  GGP: '£',
  GHC: '₵',
  GHS: 'GH₵',
  GIP: '£',
  GMD: 'D',
  GNF: 'FG',
  GTQ: 'Q',
  GYD: '$',
  HKD: '$',
  HNL: 'L',
  HRK: 'kn',
  HTG: 'G',
  HUF: 'Ft',
  IDR: 'Rp',
  ILS: '₪',
  IMP: '£',
  INR: '₹',
  IQD: 'ع.د',
  IRR: '﷼',
  ISK: 'kr',
  JEP: '£',
  JMD: 'J$',
  JOD: 'JD',
  JPY: '¥',
  KES: 'KSh',
  KGS: 'лв',
  KHR: '៛',
  KMF: 'CF',
  KPW: '₩',
  KRW: '₩',
  KWD: 'KD',
  KYD: '$',
  KZT: 'лв',
  LAK: '₭',
  LBP: '£',
  LKR: '₨',
  LRD: '$',
  LSL: 'M',
  LTC: 'LTC',
  LTL: 'Lt',
  LVL: 'Ls',
  LYD: 'LD',
  MAD: 'MAD',
  MDL: 'lei',
  MGA: 'Ar',
  MKD: 'ден',
  MMK: 'K',
  MNT: '₮',
  MOP: 'MOP$',
  MRO: 'UM',
  MRU: 'UM',
  MUR: '₨',
  MVR: 'Rf',
  MWK: 'MK',
  MXN: '$',
  MYR: 'RM',
  MZN: 'MT',
  NAD: 'N$',
  NGN: '₦',
  NIO: 'C$',
  NOK: 'kr',
  NPR: '₨',
  NZD: '$',
  OMR: '﷼',
  PAB: 'B/.',
  PEN: 'S/.',
  PGK: 'K',
  PHP: '₱',
  PKR: '₨',
  PLN: 'zł',
  PYG: 'Gs',
  QAR: '﷼',
  RMB: '￥',
  RON: 'lei',
  RSD: 'Дин.',
  RUB: '₽',
  RWF: 'R₣',
  SAR: '﷼',
  SBD: '$',
  SCR: '₨',
  SDG: 'ج.س.',
  SEK: 'kr',
  SGD: '$',
  SHP: '£',
  SLL: 'Le',
  SOS: 'S',
  SRD: '$',
  SSP: '£',
  STD: 'Db',
  STN: 'Db',
  SVC: '$',
  SYP: '£',
  SZL: 'E',
  THB: '฿',
  TJS: 'SM',
  TMT: 'T',
  TND: 'د.ت',
  TOP: 'T$',
  TRL: '₤',
  TRY: '₺',
  TTD: 'TT$',
  TVD: '$',
  TWD: 'NT$',
  TZS: 'TSh',
  UAH: '₴',
  UGX: 'USh',
  USD: '$',
  UYU: '$U',
  UZS: "so'm",
  VEF: 'Bs',
  VND: '₫',
  VUV: 'VT',
  WST: 'WS$',
  XAF: 'FCFA',
  XBT: 'Ƀ',
  XCD: '$',
  XOF: 'CFA',
  XPF: '₣',
  XRP: 'XRP',
  YER: '﷼',
  ZAR: 'R',
  ZWD: 'Z$',
};

export const paymentTypes = {
  BONUS_ACTIVATE: 'BONUS_ACTIVATE',
  BONUS_COMPLETE: 'BONUS_COMPLETE',
  BONUS_DEACTIVATE: 'BONUS_DEACTIVATE',
  CASHBACK_CREATE: 'CASHBACK_CREATE',
  CORRECTION_BALANCE_DEPOSIT: 'CORRECTION_BALANCE_DEPOSIT',
  CORRECTION_BALANCE_WITHDRAWAL: 'CORRECTION_BALANCE_WITHDRAWAL',
  CORRECTION_BONUS_DEPOSIT: 'CORRECTION_BONUS_DEPOSIT',
  CORRECTION_BONUS_WITHDRAWAL: 'CORRECTION_BONUS_WITHDRAWAL',
  DEPOSIT: 'DEPOSIT',
  WITHDRAWAL: 'WITHDRAWAL',
};

export const sportService = {
  ARCHIVED: 'ARCHIVED',
  LIVE: 'LIVE',
  PREMATCH: 'PREMATCH',
  UNSPECIFIED: 'UNSPECIFIED',
};

export const betStatuses = {
  CANCELLED: 'CANCELLED',
  CASH_OUT: 'CASH_OUT',
  HALF_LOSE: 'HALF_LOSE',
  HALF_WIN: 'HALF_WIN',
  LOSE: 'LOSE',
  UNSETTLED: 'UNSETTLED',
  VOID: 'VOID',
  WIN: 'WIN',
};

export const urlSeparator = '/';

export const BONUS_CONFLICT_ERROR_CODES = [
  'IN_PROGRESS_BONUS_EXISTS',
  'MAX_NUMBER_OF_ACTIVE_BONUSES',
  'MAX_NUMBER_OF_ACTIVATED_BONUSES',
];

export const BONUS_CONFLICT_ERROR_MESSAGES = [
  'IN_PROGRESS_BONUS_EXISTS validation failed.',
  'MAX_NUMBER_OF_ACTIVE_BONUSES validation failed.',
  'MAX_NUMBER_OF_ACTIVATED_BONUSES validation failed.',
];

export const FREE_SPIN_LOAD_STATUSES = [
  'ACTIVATION_READY',
  'PENDING_ACTIVATION',
  'ACTIVATED',
  'USED',
  'DISABLED',
  'CANCELED',
  'EXPIRED',
];

export const SPORTSBOOK_PRODUCT_TYPE = 'SPORTSBOOK';

export const bonusStatuses = {
  ACTIVATED: 'ACTIVATED',
  ACTIVATION_EXPIRED: 'ACTIVATION_EXPIRED',
  ACTIVATION_READY: 'ACTIVATION_READY',
  ACTIVE: 'ACTIVE',
  AVAILABLE: 'AVAILABLE',
  CANCELED: 'CANCELED',
  COMPLETED: 'COMPLETED',
  DISABLED: 'DISABLED',
  EXPIRED: 'EXPIRED',
  IN_PROGRESS: 'IN_PROGRESS',
  LOSE: 'LOSE',
  PENDING: 'PENDING',
  SPEND: 'SPEND',
  USED: 'USED',
  VOID: 'VOID',
  WIN: 'WIN',
};

export const FREEBET_STATUSES = {
  FREEBET_ACTIVATED: 'ACTIVATED',
  FREEBET_CANCELED: 'CANCELED',
  FREEBET_EXPIRED: 'EXPIRED',
  FREEBET_IN_PROGRESS: 'IN_PROGRESS',
  FREEBET_LOSE: 'LOSE',
  FREEBET_VOID: 'VOID',
  FREEBET_WIN: 'WIN',
};

/** Template `freeSpinSubType` (client-freespin API). `REGULAR`: `createTime + timeToUse`. `DEPOSIT`: prefer BE `expirationTime`. */
export const FREE_SPIN_SUBTYPE = {
  DEPOSIT: 'DEPOSIT',
  REGULAR: 'REGULAR',
};

/** Freespins API instance statuses (client-freespin / profile lists). */
export const FREESPIN_STATUS = {
  ACTIVATION_READY: 'ACTIVATION_READY',
  ACTIVATED: 'ACTIVATED',
  CANCELED: 'CANCELED',
  DISABLED: 'DISABLED',
  EXPIRED: 'EXPIRED',
  PENDING_ACTIVATION: 'PENDING_ACTIVATION',
  USED: 'USED',
};

export const transactionStatuses = {
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  PENDING: 'PENDING',
  PROCESSING: 'PROCESSING',
  SUCCEED: 'SUCCEED',
  SUCCESS: 'SUCCESS',
};

export const amountOfSymbolsToStartSearch = 3;
export const searchQuerySymbol = 'q';
export const cmdSymbol = '?cmd=';
export const casinoGameIdSymbol = 'casinoGameId=';

// For some sports we show word 'sets' instead of 'score'
export const SPORT_IDS_WITH_SETS = [2, 7];
// For some sports we show word 'points' instead of period description from backend
export const SPORT_IDS_WITH_POINTS = [2, 7];
// For some sports we shouldn't show period info
export const SPORT_IDS_WITHOUT_PERIOD_VIEW = [1];

export const marketGroupTypes = {
  betGroup: 'bet_group',
  marketGroup: 'market_group',
};

export const marketGroupPreferences = 'marketGroupPreferences';

export const FAVORITE_MARKET_GROUPS = 'FAVORITES';

export const LIMIT_TYPES = {
  DEPOSIT: 'DEPOSIT',
  GAME_SPENT: 'GAME_SPENT',
  SPENT: 'SPENT',
  SPORT_SPENT: 'SPORT_SPENT',
};

export const languageTypeFlag = 'flag';
export const languageTypeISO = 'iso';

export const millisecondsInDay = 86400000;

export const PLATFORM_TYPES = {
  DESKTOP: 'DESKTOP',
  MOBILE: 'MOBILE',
  MULTIPLATFORM: 'MULTIPLATFORM',
};

export const bonusTypes = {
  DEPOSIT: 'DEPOSIT',
  DEPOSIT_FREESPIN: 'DEPOSIT_FREESPIN',
  FREESPIN: 'FREESPIN',
  NO_DEPOSIT: 'NO_DEPOSIT',
  RELOAD_DEPOSIT: 'RELOAD_DEPOSIT',
  RELOAD_NO_DEPOSIT: 'RELOAD_NO_DEPOSIT',
};

export const SECOND = 1000;
export const MIN = 60 * 1000;
export const HOUR = 60 * MIN;
export const DAY = 24 * HOUR;

export const SANALBANK_BANKS = {
  11: 'Garanti Bankası',
  12: 'İş Bank',
  13: 'Ziraat Bankası',
  14: 'Akbank',
  15: 'Yapi kredi Bankası',
  16: 'Finansbank - Enpara',
  17: 'Vakifbank',
  18: 'TEB',
  19: 'Denizbank',
  20: 'Halkbank',
  21: 'ING Bank',
  22: 'Şekerbank',
  23: 'Kuveyt Türk',
  24: 'Al Baraka',
  25: 'Odeabank',
  26: 'Alternatif Bank',
  27: 'Anadolubank',
  28: 'Burgan Bank',
  29: 'Fibabanka',
  30: 'HSBC',
  31: 'ICBC',
  32: 'Turkish Bank',
  33: 'Turkiye Finans',
  34: 'Ziraat Katilim',
  35: 'Vakif Katilim',
  36: 'Emlak Katilim',
  67: 'PTT',
  68: 'Aktif Bank',
  71: 'Fast - Other',
};

export const SIMPLIFIED_SPORTSBOOK_PATH_PATTERN = '/:sportName?/:categoryName?/:tournamentName?';

export const PIX_TYPES = {
  CPF: 'cpf',
  EMAIL: 'email',
  EVP: 'evp',
  PHONE: 'phone',
};

export const PIX_TYPES_VALUES_MAX_LENGTH = {
  EMAIL: 128,
  EVP: 128,
  PHONE: 14,
};

export const CLABE_WITHDRAWAL_LENGTH = 18;

export const NON_PARAMETRIZED_MARKETS_WITH_NAME = [352, 3201];

export const POPUP_SIGN_UP_DELAY_STORAGE_KEYS = {
  NEXT_SHOW: 'popupSignUpDelayNextShow',
  TIMEOUT_ID: 'popupSignUpDelayTimeoutId',
};

export const SPORT_IDS_WITH_DETAILED_SCORE = [2, 3, 6, 7, 17, 34];

export const MATCH_WINNER_SPORT_IDS = [
  346, 396, 772, 1013, 2, 48, 156, 2875, 2920, 1416, 2659, 2680, 3034, 2970, 1200, 1216, 2983, 3056,
  3055, 5551, 1521, 1750, 1772, 1770, 1821, 3321, 3330, 3342, 2801, 2849, 1714, 2990, 3033, 5569,
  2969, 10821, 10822, 5549, 2000, 2017, 1600, 1619, 10799, 3065, 3104, 3103, 2555, 2578, 2576, 2610,
  1900, 1914, 2100, 2116, 2149, 2962, 11029, 2959, 5533, 2424, 2460, 3052, 5576, 10802, 10927,
];

export const OUTRIGHTS_DEFAULT_VIEW = [10951, 10952];

export const HIDE_FREEBET_FOR_CURRENT_SESSION = 'HideFreebetForCurrentSession';
export const POPUP_MESSAGES_STORAGE_KEY = 'isMessagePopupShowed';

export const CXFROM_STORAGE_KEY = 'cxfrom';
export const BTAG_STORAGE_KEY = 'btag';

export const OAUTH_FLOW_TYPE_STORAGE_KEY = 'oauth_flow_type';

export const OAUTH_FLOW_TYPES = {
  SIGNIN: 'signin',
  SIGNUP: 'signup',
  SIGNUP_MULTISTEP: 'signup_multistep',
};

export const KYC_AUTO_RUN_KEY = 'kycAutoRun';

export const TERMINAL_LOGIN_UID_STORAGE_KEY = 'terminal_login';

export const SITE_OPENING_DISABLED_POPUP_STORAGE_KEY = 'siteOpeningPopup';
export const SIGN_IN_POPUP_STORAGE_KEY = 'signinMultiPopup';
export const SIGN_UP_POPUP_STORAGE_KEY = 'signupMultiPopup';
export const ADULT_COOKIE_NAME = 'adult_confirmation';
export const REGISTRATION_FLOW_ACTIVE_STORAGE_KEY = 'registrationFlowActive';

export const ERRORS_MAP = {
  NOT_FOUND: 'book_a_bet_error_invalid_id',
};

export const ARCHIVED_EVENT_EXTRA_DATA_STORAGE_KEY = 'archivedEventExtraData';

export const userVerificationStatuses = {
  NEW: 'NEW',
  UNCONFIRMED: 'UNCONFIRMED',
};

export const MIN_SEARCH_STRING_LENGTH = 3;
export const SEARCH_DEBOUNCE_TIMER = 300;

/* eslint-disable */
export const DIRECTA_BANKS = {
  16: 'first_bank_nigeria_plc',
  30: 'heritage_bank',
  32: 'union_bank_nigeria_plc',
  33: 'united_bank_africa_plc',
  35: 'wema_bank_plc',
  44: 'access_bank',
  50: 'ecobank_nigeria',
  57: 'zenith_bank',
  58: 'guaranty_trust_bank_plc',
  70: 'fidelity_bank_plc',
  82: 'keystone_bank_ltd',
  214: 'first_city_monument_bank',
  215: 'unity_bank_plc',
  232: 'sterling_bank_plc',
  301: 'jaiz_bank',
};

export const ADULT_POPUP_STATE = {
  FORBIDDEN: 0,
  GRANTED: 1,
  SELECTION: 2,
};

export const PROMO_CODES_ERRORS = {
  DEFAULT: 'promocode_not_exist',
  PROMO_CODE_ACTIVATIONS_EXCEEDED: 'promocode_expired',
  PROMO_CODE_ACTIVATIONS_PER_CLIENT_EXCEEDED: 'promocode_exhausted',
  PROMO_CODE_ALREADY_FINISHED: 'promocode_expired',
  PROMO_CODE_ARCHIVED: 'promocode_expired',
  PROMO_CODE_NOT_FOUND: 'promocode_not_exist',
  PROMO_CODE_NOT_STARTED_YET: 'promocode_not_active_yet',
};

export const DATA_LAYER_STORAGE_KEYS = {
  CASHBOX_DEPOSIT_CLICKED: 'cashboxDepositClicked',
  CASHBOX_OPENED: 'cashboxOpened',
  LEAVING_REGISTRATION_POPUP_CLOSED: 'leavingRegistrationPopupClosed',
  LEAVING_REGISTRATION_POPUP_CTA_CLICKED: 'leavingRegistrationPopupCtaCliClicked',
  LEAVING_REGISTRATION_POPUP_SHOWN: 'leavingRegistrationPopupShown',
  QUICK_DEPOSIT_BUTTON_CLICKED: 'quickDepositButtonClicked',
  REGISTRATION_BUTTON_CLICKED: 'registrationButtonClicked',
  REGISTRATION_STEP: step => `registrationStep${step}`,
};

export const ALWAYS_ALLOWED_PAGES = ['/signin', '/login', '/signup', '/page/terms-and-conditions'];

export const ACCOUNT_NUMBERS_POPUP_TYPES = {
  DEPOSIT: 'deposit',
  WITHDRAWAL: 'withdrawal',
};

export const ACCOUNT_STATUSES = {
  PARTIALLY_REGISTERED: 'PARTIALLY_REGISTERED',
};

export const REDIRECT_DATA_AFTER_DEPOSIT = 'redirectDataAfterDeposit';
export const DEPOSIT_FAILED = 'DEPOSIT_FAILED';

export const POSTHOG_EVENTS = {
  REGISTRATION: 'registration',
  DEPOSIT_LOADER_SHOWN: 'deposit_loader_shown',
  DEPOSIT_REDIRECT_SUCCESS: 'deposit_redirect_success',
  DEP_POP_UP_SHOWN: 'dep_pop_up_shown',
  QUICK_DEP_POP_UP_SHOWN: 'quick_dep_pop_up_shown',
  ALTERNATIVE_PAYMENT_METHOD_POP_UP: 'alternative_payment_method_pop-up',
};

export const POSTHOG_CTA = {
  NEXT_STEP: 'next_step',
  BACK_TO_PREV_STEP: 'back_to_prev_step',
  BACK_TO_REG: 'back_to_reg',
  DEPOSIT: 'deposit',
};

export const POSTHOG_SESSION_KEYS = {
  DEPOSIT_PAGE_REFER: 'posthog_deposit_page_refer',
  LAST_DEPOSIT_PAGE_REFER: 'posthog_last_deposit_page_refer',
};

export const POSTHOG_PAGE_REFER = {
  ALTERNATIVE_PAYMENT_METHOD_POP_UP: 'alternative payment_method pop-up',
  BONUSES: '/bonuses',
  CASINO: '/casino',
  PROMO: '/promo',
};

export const LEAVE_SIGNUP_NOTIFICATION_ID = 'leaveSignup';

export const SPORTSBOOK_PROVIDERS = {
  ALTENAR: 'Altenar',
};

export const {
  ACTIVATED,
  ACTIVATION_EXPIRED,
  ACTIVATION_READY,
  ACTIVE,
  CANCELED,
  COMPLETED,
  DISABLED,
  EXPIRED,
  IN_PROGRESS,
  PENDING,
  PENDING_ACTIVATION,
  SPEND,
  USED,
} = bonusStatuses;

export const statusOrder = {
  [ACTIVATED]: 2,
  [ACTIVATION_READY]: 4,
  [ACTIVE]: 5,
  [CANCELED]: 11,
  [COMPLETED]: 7,
  [DISABLED]: 12,
  [EXPIRED]: 10,
  [IN_PROGRESS]: 1,
  [PENDING]: 6,
  [PENDING_ACTIVATION]: 3,
  [SPEND]: 9,
  [USED]: 8,
};

export const freebetStatusOrder = {
  [FREEBET_STATUSES.FREEBET_ACTIVATED]: 1,
  [FREEBET_STATUSES.FREEBET_IN_PROGRESS]: 2,
  [FREEBET_STATUSES.FREEBET_WIN]: 3,
  [FREEBET_STATUSES.FREEBET_LOSE]: 4,
  [FREEBET_STATUSES.FREEBET_EXPIRED]: 5,
  [FREEBET_STATUSES.FREEBET_CANCELED]: 6,
  [FREEBET_STATUSES.FREEBET_VOID]: 7,
};

export const COOKIES_ACCEPTED_EVENT = 'cookies:accepted';
/* eslint-enable */

export const OAUTH_AUTH_TOKEN_COOKIE = 'x-auth-token';
export const OAUTH_REGISTER_INFO_COOKIE = 'x-register-info';
export const OAUTH_REGISTER_INFO_TOKEN_STORAGE_KEY = 'oauth_registration_token';

export const PASSWORD_FIELDS_NAMES = {
  PASSWORD: 'PASSWORD',
  PASSWORD_CONFIRMATION: 'PASSWORD_CONFIRMATION',
};

export const SPECIAL_ICONS_CONFIG = [
  { icon: 'missions', iconName: 'i-missions' },
  { icon: 'store', iconName: 'i-store' },
];
